function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "trash-alt-f",
  d: "M11.016,4.473l-.5,9.027a1.491,1.491,0,0,1-1.489,1.409H2.9A1.491,1.491,0,0,1,1.413,13.5l-.5-9.027ZM.745,0H11.181a.745.745,0,0,1,.745.745V2.236a.745.745,0,0,1-.745.745H.745A.745.745,0,0,1,0,2.236V.745A.745.745,0,0,1,.745,0ZM4.473,5.963a.745.745,0,0,0-.745.745v5.218a.745.745,0,0,0,1.491,0V6.709A.745.745,0,0,0,4.473,5.963Zm2.982,0a.745.745,0,0,0-.745.745v5.218a.745.745,0,0,0,1.491,0V6.709A.745.745,0,0,0,7.454,5.963Z",
  fill: "#ccc"
});

function SvgTrashAltF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.927,
    height: 14.908,
    viewBox: "0 0 11.927 14.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAltF);
export default ForwardRef;